<template>
  <div>
    <div class="row">
      <div class="col-md-6 header-row">
        <h3 class="heading semi-bold">Fabrics in this books</h3>
      </div>
      <div class="col-md-3 header-row">
        <h3 class="heading semi-bold">Fabrics available</h3>
      </div>
      <div class="col-md-3 header-row">
        <div class="input-group transparent">
          <span class="input-group-addon">
            <i class="fa fa-search" aria-hidden="true"></i>
          </span>
          <input
            type="text"
            class="form-control search-fabric"
            @keyup.enter="searchFabric($event.target.value)"
            placeholder="Search Fabric"
          />
        </div>
      </div>
    </div>
    <div class="grid shadow bg-white mt-20">
      <div class="grid-body">
        <div class="row">
          <div class="col-md-6">
            <div class="table-div">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="action-cell"></th>
                    <th class="action-cell"></th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th class="action-cell"></th>
                  </tr>
                </thead>
                <draggable
                  v-if="bookFabrics.length > 0"
                  :list="bookFabrics"
                  tag="tbody"
                  @sort="updateFabricOrder"
                >
                  <tr v-for="row in bookFabrics" :key="row.id">
                    <td class="text-center">
                      <input
                        type="checkbox"
                        :value="row"
                        v-model="selectedBookFabrics"
                      />
                    </td>
                    <td class="text-center">
                      <span class="sort-handle"
                        ><i class="fa fa-bars"></i
                      ></span>
                    </td>
                    <td class="text-bold">
                      {{ $Fabric.getCode(row.id) }}
                    </td>
                    <td>
                      {{ row.name }}
                    </td>
                    <td>
                      <span
                        :class="'badge badge-' + getStatusColor(row.status)"
                      >
                        {{ row.status.replace(/_/g, " ") }}
                      </span>
                    </td>
                    <td class="text-center fabric-action">
                      <span
                        @click="removedFabricFromBook(row)"
                        v-if="!isReadOnlyUser"
                        ><i class="fa fa-minus"></i
                      ></span>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
            <div class="text-right bulk-fabric-action">
              with selected
              <button
                type="button"
                class="btn btn-danger"
                @click="removeSelectedFabricsFromBook()"
                v-if="!isReadOnlyUser"
                :disabled="selectedBookFabrics.length == 0"
              >
                Remove all &raquo;
              </button>
            </div>
          </div>
          <div class="col-md-6">
            <div class="table-div">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="action-cell"></th>
                    <th @click="sort('id')" class="sort">ID</th>
                    <th @click="sort('name')" class="sort">Name</th>
                    <th @click="sort('status')" class="sort">Status</th>
                    <th @click="sort('out_of_stock_date')" class="sort">
                      Oos date
                    </th>
                    <th class="action-cell"></th>
                  </tr>
                </thead>
                <tbody v-if="rows.length > 0">
                  <tr v-for="row in rows" :key="row.id">
                    <td class="text-center">
                      <input
                        type="checkbox"
                        :value="row"
                        v-model="selectedAvailableFabrics"
                      />
                    </td>
                    <td class="text-bold">
                      {{ $Fabric.getCode(row.id) }}
                    </td>
                    <td>
                      {{ row.name }}
                    </td>
                    <td>
                      <span
                        :class="'badge badge-' + getStatusColor(row.status)"
                      >
                        {{ row.status.replace(/_/g, " ") }}
                      </span>
                    </td>
                    <td class="text-center">
                      {{ row.out_of_stock_date }}
                    </td>
                    <td class="text-center fabric-action">
                      <span @click="addFabricToBook(row)" v-if="!isReadOnlyUser"
                        ><i class="fa fa-plus"></i
                      ></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="bulk-fabric-action">
              <button
                type="button"
                class="btn btn-primary"
                @click="addSelectedFabricsToBook()"
                v-if="!isReadOnlyUser"
                :disabled="selectedAvailableFabrics.length == 0"
              >
                &laquo; Add all
              </button>
              with selected
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fabric, { OEM_FABRIC_ID_START } from "@/pages/Tools/Fabric";
import draggable from "vuedraggable";
import fabricColumns from "@/pages/Fabric/tools/fabricColumns";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      allFabrics: [],
      availableFabrics: [],
      bookFabrics: [],
      rows: [],
      selectedBookFabrics: [],
      selectedAvailableFabrics: [],
    };
  },
  props: {
    modelValue: {
      type: [Object],
      default: {},
    },
    isReadOnlyUser: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {
    async loadFabrics() {
      this.bookFabrics = this.modelValue.fabrics;

      /*
       * Default query parameters
       */
      let queryParams = {
        columns: "id,name,image_url,status,future",
        custom_fields: "out_of_stock_date,rating",
        per_page: 0,
      };

      /*
       * Extra columns added by the user
       */
      if (this.columnsToCompare) {
        queryParams.columns += "," + this.columnsToCompare.join(",");
      }

      let response = await axios.get("/v2/fabrics", {
        params: queryParams,
      });

      this.allFabrics = response.data.data.collection;

      /**
       * Filter out OEM fabrics, they should not be display in public products, like fabric books.
       * @type {*[]}
       */
      this.allFabrics = this.allFabrics.filter((f) => {
        return f.id < OEM_FABRIC_ID_START;
      })

      // f['is_selected'] = false;

      this.allFabrics.map((f) => {
        f["oos_date_int"] = parseInt(f["out_of_stock_date"]);

        let outOfStockDate =
          f["oos_date_int"] > 0
            ? moment.unix(f["oos_date_int"]).format("DD MMM, YYYY")
            : "";

        if (f["oos_date_int"] < 0) {
          outOfStockDate = "No data";
        }

        f["out_of_stock_date"] = outOfStockDate;

        if (f["used_calculation_value"] && f["oos_date_int"] > 0) {
          f["out_of_stock_date"] =
            f["out_of_stock_date"] + " (" + f["used_calculation_value"] + ")";
        }

        f["is_selected"] = false;

        return f;
      });

      this.availableFabrics = this.allFabrics.filter((fabric) => {
        let value = this.bookFabrics.find(function (bookFabric) {
          return bookFabric.id === fabric.id;
        });

        return value === undefined;
      });
      this.rows = this.availableFabrics;
    },
    getStatusColor(status) {
      if (["available"].includes(status)) {
        return "primary";
      } else if (
        ["soon_sold_out_not_coming_back", "soon_sold_out_coming_back"].includes(
          status
        )
      ) {
        return "warning";
      } else {
        return "danger";
      }
    },
    /**
     * Add multiple fabrics to the current book
     * This method is called when the user click on the [Add all with selected]
     */
    async addFabricsToBook(fabrics) {
      // Get the ids of the fabrics to be added
      let fabricIds = fabrics.map((f) => f.id);

      try {
        if (this.modelValue.id) {
          let response = await axios.post(
            `/v2/fabrics/book/${this.modelValue.id}/fabrics`,
            {
              fabrics: fabricIds,
            }
          );
          if (response.data.status === "OK") {
            toastr.success("Fabrics successfully added to the book");
          }
        }

        // Add the fabrics to fabric book list
        this.bookFabrics.push(...fabrics);

        this.modelValue.fabricIds = this.bookFabrics.map((f) => f.id);

        // Remove the fabrics from available
        // We only retain the fabrics that are not in fabricIds
        this.availableFabrics = this.availableFabrics.filter((fabric) => {
          return fabricIds.indexOf(fabric.id) < 0;
        });

        // remove the fabrics from selected available fabrics if any
        this.selectedAvailableFabrics = this.selectedAvailableFabrics.filter(
          (fabric) => {
            return fabricIds.indexOf(fabric.id) < 0;
          }
        );

        // Update the table rows
        this.rows = this.availableFabrics;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    /**
     * Add a single fabric to the current book.
     * This function is used when the user click on the (+) button on the list of available fabric.
     * It is also a shortcut to the addFabricsToBook method above.
     */
    async addFabricToBook(fabric) {
      this.addFabricsToBook([fabric]);
    },
    /**
     *
     */
    async removedFabricFromBook(fabric) {
      this.removedFabricsFromBook([fabric]);
    },
    async removedFabricsFromBook(fabrics) {
      // Get the ids of the fabrics to add
      let fabricIds = fabrics.map((f) => f.id);

      try {
        if (this.modelValue.id) {
          let response = await axios.delete(
            `/v2/fabrics/book/${this.modelValue.id}/fabrics`,
            {
              data: {
                fabrics: fabricIds,
              },
            }
          );
          if (response.data.status === "OK") {
            toastr.success("Fabrics successfully removed from the book");
          }
        }

        // Add the fabrics to available fabric list
        this.availableFabrics.push(...fabrics);

        // Remove the fabrics from fabric book
        this.bookFabrics = this.bookFabrics.filter((f) => {
          return fabricIds.indexOf(f.id) < 0;
        });

        this.modelValue.fabricIds = this.bookFabrics.map((f) => f.id);

        // remove the fabrics from selected fabric books if any
        this.selectedBookFabrics = this.selectedBookFabrics.filter((fabric) => {
          return fabricIds.indexOf(fabric.id) < 0;
        });

        // Update the table rows
        this.rows = this.availableFabrics;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    searchFabric(search) {
      if (search !== "") {
        this.rows = this.availableFabrics.filter((obj) => {
          let strCode = Fabric.getCode(obj.id) + "";
          return (
            strCode === search ||
            obj.name.toLowerCase().includes(search.toLowerCase())
          );
        });
      } else {
        this.rows = this.availableFabrics;
      }
    },
    removeSelectedFabricsFromBook() {
      this.removedFabricsFromBook(this.selectedBookFabrics);
    },
    addSelectedFabricsToBook() {
      this.addFabricsToBook(this.selectedAvailableFabrics);
    },
    async updateFabricOrder(event) {
      let fabricIds = this.bookFabrics.map((f) => f.id);

      this.modelValue.fabricIds = fabricIds;

      try {
        if (this.modelValue.id) {
          let response = await axios.put(
            `/v2/fabrics/book/${this.modelValue.id}/fabrics`,
            {
              fabrics: fabricIds,
            }
          );

          if (response.data.status === "OK") {
            toastr.success("The order of the fabrics was successfully changed");
          } else {
            toastr.error(
              "There was an error while trying to update the order of the fabrics"
            );
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    sort(column) {
      this.sortType = this.sortType === "asc" ? "desc" : "asc";
      let module = this;
      this.rows = _.orderBy(
        this.rows,
        function (row) {
          let columnType = module.getColumnType(column);
          if (columnType === "numeric") {
            return row[column] || 0;
          } else {
            return row[column] || "";
          }
        },
        [this.sortType]
      );
    },
    getColumnType(column) {
      for (let i in fabricColumns) {
        let info = fabricColumns[i];
        if (info.key === column) {
          return info.hasOwnProperty("type") ? info.type : "string";
        }
      }
    },
  },
};
</script>

<style scoped>
@import "~vue-good-table/dist/vue-good-table.css";
.table-div {
  overflow: scroll;
  height: 600px;
}
.fabric-action span {
  background: #767676;
  color: #fff;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
  text-align: center;
  cursor: pointer;
}
.action-cell {
  width: 50px;
}
.bulk-fabric-action {
  margin-top: 25px;
}
</style>
